import React, { createContext, useContext, useMemo, useState } from "react";
import { apiFetch, getToken, setToken, clearToken } from "../api/client";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setTok] = useState(() => getToken());
  const [admin, setAdmin] = useState(null);

  const login = async (username, password) => {
    const data = await apiFetch("/api/admin/login", {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: { Authorization: "" }, // never send a stale token on login
    });
    setToken(data.token);
    setTok(data.token);
    setAdmin(data.admin || null);
    return data;
  };

  const logout = () => {
    clearToken();
    setTok("");
    setAdmin(null);
  };

  const value = useMemo(() => ({ token, admin, login, logout }), [token, admin]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
